import React, { useEffect, useState } from 'react';
import { Flag, Menu, X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Mission',
    href: '/#mission'
  }, {
    name: 'Issues',
    href: '/#issues'
  }, {
    name: 'Leadership',
    href: '/#leadership'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-pac-navy/95 backdrop-blur-md shadow-lg py-3' : 'bg-pac-navy py-5'}`} data-id="element-147" data-mp="9izzvjwd1toc">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148" data-mp="1kyye026eb5wf">
        <div className="flex justify-between items-center" data-id="element-149" data-mp="9ozgwjmurzzy">
          <Link to="/" className="flex items-center gap-2" aria-label="AZ City PAC home" data-id="element-150" data-mp="9qu09tih7k1x">
            <Flag className="h-8 w-8 text-pac-gold" data-id="element-151" data-mp="jm3zyalejfcj" />
            <div className="flex flex-col" data-id="element-152" data-mp="jkkk2l3nr6ba">
              <span className="font-serif font-bold text-xl leading-tight text-white tracking-wide uppercase" data-id="element-153" data-mp="om07gjtb5owu">
                AZ City
              </span>
              <span className="text-[10px] font-sans font-semibold text-pac-gold tracking-[0.2em] uppercase" data-id="element-154" data-mp="3n19krqgk7lt1">
                Political Action Committee
              </span>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-8" aria-label="Primary navigation" data-id="element-155" data-mp="ub8iklze26x">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-200 hover:text-white transition-colors uppercase tracking-wider" data-id="element-156" data-mp="34ccxi6jkxtkb">
                {link.name}
              </a>)}
            <Link to="/news" className="text-sm font-medium text-slate-200 hover:text-white transition-colors uppercase tracking-wider" data-id="element-157" data-mp="2wb58wd2g3h5f">
              News
            </Link>
            <a href="/#donate" className="bg-pac-red hover:bg-red-800 text-white px-6 py-2.5 rounded font-bold tracking-wider uppercase transition-all shadow-[0_0_15px_rgba(185,28,28,0.5)] hover:shadow-[0_0_25px_rgba(185,28,28,0.8)] transform hover:-translate-y-0.5" data-id="element-158" data-mp="362i33bbpujem">
              Donate Now
            </a>
          </nav>

          <button type="button" className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" aria-expanded={mobileMenuOpen} data-id="element-159" data-mp="2nb8seyq7lolg">
            {mobileMenuOpen ? <X className="h-6 w-6" data-id="element-160" data-mp="a523lbx62wau" /> : <Menu className="h-6 w-6" data-id="element-161" data-mp="a3hazruexnfm" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-162" data-mp="f56orf90sf7e">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-pac-navy border-t border-slate-800 overflow-hidden" data-id="element-163" data-mp="14vus3ceyki0">
            <nav className="px-4 py-6 flex flex-col gap-4" aria-label="Mobile navigation" data-id="element-164" data-mp="k3hylpzbeppm">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-slate-200 hover:text-white uppercase tracking-wider block py-2" data-id="element-165" data-mp="1bu5wmt5ozez2">
                  {link.name}
                </a>)}
              <Link to="/news" onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-slate-200 hover:text-white uppercase tracking-wider block py-2" data-id="element-166" data-mp="3k22mp3aim4pn">
                News
              </Link>
              <a href="/#donate" onClick={() => setMobileMenuOpen(false)} className="bg-pac-red text-white px-6 py-4 rounded font-bold tracking-wider uppercase text-center mt-4" data-id="element-167" data-mp="bnkbwtt6wb2c">
                Donate Now
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}